import styled from "@emotion/styled";

export const VerticalGap = styled.div`
  height: ${(props) => (props.size ? props.size : "20px")};
  width: 100%;
`;

export const VerticalGapWithLine = styled.div`
  height: 1px;
  margin: 10px 0px;
  width: 100%;
  background-color: #dfdfdf;
`;

export const HorizontalGap = styled.div`
  width: ${(props) => (props.size ? props.size : "20px")};
  height: 100%;
`;
